import { _HTMLElement, HAS_SHADY_CSS, createTemplate } from '../utils';

/**
 * Defines an HTML template to use with all instances of the resulting class.
 *
 * @category mixin
 * @param {String} html HTML string that's cloned into a DOM node for each class instance, available through the private member `this._template`.
 * @param {Class} [Base=HTMLElement] Optional base class to extend from.
 * @returns {Class}
 * @example
 ```js
import { withTemplate } from '@updater-legacy/components/custom-element';
import html from './index.html';

class MyCustomElement extends withTemplate(html)() {
  constructor() {
    super();
    this.appendChild(this._template);
  }
}
```
 */
export const withTemplate = (html) => (Base = _HTMLElement) => class extends Base {
    constructor() {
      super();

      if (!this.constructor._template) {
        const template = createTemplate(html);

        if (HAS_SHADY_CSS) {
          // Scope styles to support ShadowDOM (out of scope for this mixin).
          // ShadyCSS handles this automagically for DOM that's added async
          // (via MutationObserver), but not for DOM that's added sync.
          // TODO: Figure out better solution.
          window.ShadyCSS.prepareTemplate(template, this.localName);
        }

        this.constructor._template = template;
      }

      this._template = this.constructor._template.content.cloneNode(true);
    }
  };
